/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SellerOfRecordEnum } from './sellerOfRecordEnum';


export interface SubscriptionSpec { 
    seller?: SellerOfRecordEnum;
    seller_id?: number;
}
export namespace SubscriptionSpec {
}


